(function () {
    'use strict';

    angular
        .module('ui.modal.module',
            [
                'ngAnimate',
                'ui.bootstrap'
            ]);

})();